import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LoadingService } from '@core/shared';
import { Pagination } from '@app/core/shared/models/pagination';
import { SearchCriteria } from '@app/core/shared/models/search-criteria';
import { Sorter } from '@app/core/shared/models/sorter';
import { LeaderboardService } from '../../services/leaderboard.services';
import { FormControl } from '@angular/forms';

@UntilDestroy()
@Component({
    selector: 'app-leaderboard-selectpartner-view',
    templateUrl: 'selectpartner.component.html',
    styleUrls: ['selectpartner.component.scss']
})
export class SelectPartnerLeaderboardComponent implements OnInit {
    searchCriteria: SearchCriteria = new SearchCriteria('firmName');
    paginationDetails: Pagination = new Pagination();
    sorter: Sorter = new Sorter('firmName', false);
    tableData: any[] = [];
    leaderboardQuarterData: any[] = [];
    selectQuarter = new FormControl();
    hideTableCellOnLoad: boolean = true;
    constructor(public loadingService: LoadingService, private leaderboardService: LeaderboardService) { }

    ngOnInit() {
        this.loadingService.doLoading(this.leaderboardService.getLeaderboardQuarters(), this).pipe(untilDestroyed(this)).subscribe(response => {
            this.leaderboardQuarterData = response;
            const currentValue = response.find(x => x.isCurrentQuarter);
            this.selectQuarter.setValue(currentValue?.id ? currentValue : '');
            this.getLeaderboardData(currentValue?.id || null);
        }, (err) => {
            this.hideTableCellOnLoad = false;
        });
        this.selectQuarter.valueChanges.subscribe(x => {
            this.getLeaderboardData(x?.id || null);
        })
    }

    getLeaderboardData(id) {
        this.searchCriteria.itemsPerPage = this.paginationDetails.itemsPerPage;
        this.searchCriteria.pageNumber = this.paginationDetails.pageNumber;
        this.searchCriteria.sortField = this.sorter.sortColumn;

        this.searchCriteria.sortAscending = this.sorter.sortDirection;
        this.loadingService.doLoading(this.leaderboardService.getLeaderboardData('selectpartner', { quarterId: id, pageNumber: this.paginationDetails.pageNumber || 1 }), this).pipe(untilDestroyed(this)).subscribe(response => {
            this.paginationDetails.totalNumberOfItems = response?.totalNumberOfItems || 0;
            this.tableData = response?.data || [];
            this.hideTableCellOnLoad = false;
        }, (err) => {
            this.hideTableCellOnLoad = false;
        });
        // this.loadingService.doLoading(this.leaderboardService.getLeaderboardData({ pageNumber: this.paginationDetails.pageNumber || 1 }), this).pipe(untilDestroyed(this)).subscribe(response => {
        //     this.paginationDetails.totalNumberOfItems = response?.totalNumberOfItems;
        //     this.tableData = response;
        // });
    }

    onChange(pagination: Pagination) {
        this.paginationDetails = pagination;
        this.getLeaderboardData(this.selectQuarter.value?.id || null);
    }

    onSort(sortField) {
        this.sorter.sort(sortField);
    }
}